import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";


const data = [
	{
		"desc":
			"This role is reserved for the owner or person within the dealer organization with the authority to execute Sony's Dealer Agreement and maintain authorized users",
		"role": "Principal/Owner",
		"contracts": true,
		"assets": true,
		"logos": true,
		"sales": true,
		"parts": true,
		"rebates": true,
		"products": true,
		"view": true,
		"credit": true,
		"return": true,
		"history": true,
	},
	{
		"desc":
			"This role is assigned by the Principal/Owner and is able to access everything that the Principal/Owner has access to except for the Sony Dealer Agreement",
		"role": "Admin",
		"contracts": true,
		"assets": true,
		"logos": true,
		"sales": true,
		"parts": true,
		"rebates": true,
		"products": true,
		"view": true,
		"credit": true,
		"return": true,
		"history": true,
	},
	{
		"desc": "This role receives Sony Sales News communications and has the ability to view the product catalog and create price books",
		"role": "Sales News",
		"contracts": false,
		"assets": true,
		"logos": true,
		"sales": true,
		"parts": true,
		"rebates": true,
		"products": false,
		"view": true,
		"credit": false,
		"return": false,
		"history": false,
	},
	{
		"desc": "This role has the ability to view the product catalog",
		"role": "Dealer Source Only",
		"contracts": false,
		"assets": true,
		"logos": true,
		"sales": false,
		"parts": true,
		"rebates": true,
		"products": false,
		"view": false,
		"credit": false,
		"return": false,
		"history": false,
	},
	{
		"desc":
			"This role is for persons within the organization who have the authority to place orders, request credits and returns. This role also receives Sony Sales News communications",
		"role": "Purchasing/Buyer",
		"contracts": false,
		"assets": true,
		"logos": true,
		"sales": true,
		"parts": true,
		"rebates": true,
		"products": true,
		"view": true,
		"credit": true,
		"return": true,
		"history": true,
	},
	{
		"desc": "This role is for an accounting person that have the authority to request returns and credits, but not place orders",
		"role": "Accounting",
		"contracts": false,
		"assets": false,
		"logos": false,
		"sales": false,
		"parts": false,
		"rebates": false,
		"products": false,
		"view": true,
		"credit": true,
		"return": true,
		"history": true,
	},
	{
		"desc": "This role is for a person to view purchase and credit historical data",
		"role": "ExpressNet View only",
		"contracts": false,
		"assets": false,
		"logos": false,
		"sales": false,
		"parts": false,
		"rebates": false,
		"products": false,
		"view": true,
		"credit": false,
		"return": false,
		"history": true,
	},
];

const blackThickBorder = "3px solid rgb(0, 0, 0)";
const blackThinBorder = "1px solid rgb(0, 0, 0)";

const tableCss = {
	headerCss: { backgroundColor: "rgba(0, 198, 212, 1)", "&:hover": { backgroundColor: "rgba(0, 198, 212, 1)" } },
	title: { border: blackThinBorder, borderTop: blackThickBorder, borderBottom: blackThickBorder, color: "white", minWidth: 85 },
	title: { border: blackThinBorder, borderTop: blackThickBorder, borderBottom: blackThickBorder, color: "white", minWidth: 85 },
	borderLeft: { borderLeft: blackThickBorder },
	borderRight: { borderRight: blackThickBorder },
	borderBottom: { border: blackThickBorder },
	fullBorder: { border: blackThinBorder },
	allowed: { backgroundColor: "rgba(204, 255, 255, 1)", border: blackThinBorder },
	notAllowed: { border: blackThinBorder },
};

export default function RoleDescriptionMatrix() {
	return (
		<TableContainer component={Paper}>
			<Table aria-label='customized table'>
				<TableHead>
					<TableRow sx={{ backgroundColor: "white" }}>
						<TableCell></TableCell>
						<TableCell></TableCell>
						<TableCell align='center' colSpan={6}>
							Roles for dealer portal
						</TableCell>
						<TableCell align='center' colSpan={5}>
							Only applicable to direct dealers
						</TableCell>
					</TableRow>
					<TableRow sx={{ backgroundColor: "white" }}>
						<TableCell></TableCell>
						<TableCell></TableCell>
						<TableCell sx={{ border: blackThickBorder }} align='center' colSpan={6}>
							Dealer Source
						</TableCell>
						<TableCell sx={{ border: blackThickBorder }} align='center' colSpan={5}>
							ExpressNet
						</TableCell>
					</TableRow>
					<TableRow sx={tableCss.headerCss}>
						<TableCell sx={{ minWidth: 500, border: blackThickBorder, background: "black", color: "white" }}>Description</TableCell>
						<TableCell sx={{ border: blackThickBorder, background: "black", color: "white" }} align='center'>
							Role
						</TableCell>
						<TableCell sx={{ ...tableCss.title, ...tableCss.borderLeft }} align='center'>
							Contracts & Dealer Contacts
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Product Assets
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Logos
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Sales News
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Order Parts
						</TableCell>
						<TableCell sx={{ ...tableCss.title, ...tableCss.borderRight }} align='center'>
							Rebates & SPIFFS
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Order Products
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							View Product Catalog
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Credit Request
						</TableCell>
						<TableCell sx={tableCss.title} align='center'>
							Return Request
						</TableCell>
						<TableCell sx={{ ...tableCss.title, ...tableCss.borderRight }} align='center'>
							View History
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody sx={tableCss.borderBottom}>
					{data.map((dt) => (
						<TableRow key={dt.desc}>
							<TableCell sx={{ border: blackThinBorder }}>{dt.desc}</TableCell>
							<TableCell sx={{ border: blackThinBorder }} align='center'>
								{dt.role}
							</TableCell>
							<PermissionCell isAllowed={dt.contracts} leftBorder />
							<PermissionCell isAllowed={dt.assets} />
							<PermissionCell isAllowed={dt.logos} />
							<PermissionCell isAllowed={dt.sales} />
							<PermissionCell isAllowed={dt.parts} />
							<PermissionCell isAllowed={dt.rebates} rightBorder />
							<PermissionCell isAllowed={dt.products} />
							<PermissionCell isAllowed={dt.view} />
							<PermissionCell isAllowed={dt.credit} />
							<PermissionCell isAllowed={dt.return} />
							<PermissionCell isAllowed={dt.history} rightBorder />
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

function PermissionCell({ isAllowed, leftBorder, rightBorder }) {
	const styleObject = {
		...(isAllowed ? tableCss.allowed : tableCss.notAllowed),
		...(leftBorder ? tableCss.borderLeft : {}),
		...(rightBorder ? tableCss.borderRight : {}),
	};
	return (
		<TableCell sx={styleObject} align='center'>
			{isAllowed ? "✓" : " "}
		</TableCell>
	);
}
